<template>
  <button
    :disabled="disabled"
    class="base-button"
    :class="{
      altcolor,
      secondary: isSecondary,
      small: isSmall
    }"
    :type="type"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    altcolor: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "button"
    },
    isSecondary: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.base-button {
  display: block;
  width: 100%;
  color: $color-white;
  background-color: $color-blue-300;
  text-align: center;
  padding: 13px 0;
  font-size: $font-size-l;

  &.altcolor {
    background-color: $color-blue-200;
  }

  &.small {
    font-size: $font-size-m;
    width: auto;
    padding: 13px 39px;
  }

  &.secondary {
    color: $color-black;
    background-color: transparent;
    padding: 13px;
  }

  &[disabled] {
    background-color: $color-grey-400;
  }
}
</style>
